import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    INVALIDATE_IMPERSONATION_SUCCESS,
    INVALIDATE_IMPERSONATION_FAILURE,
} from '../actions';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* invalidateImpersonation() {
    // const params = convertObjectToQueryParams({ ...action.payload });

    let basesiteid = localStorage.getItem('baseSiteId');

    const url = `/occ/v2/${basesiteid}/impersonation/invalidate`;

    try {
        const result = yield axios.post(url).then((response) => response.data);

        yield put({ type: INVALIDATE_IMPERSONATION_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: { basesiteid }
        });
        yield put({
            type: INVALIDATE_IMPERSONATION_FAILURE,
            templateError: true,
        });
    }
}
